export function CoreReorderGridDirective (
  KEYCODES
) {
  return {
    link: function ( scope, element ) {
      var index = -1;
      var lastActive;
      var lastSelected;
      var array = function () {
        return scope.renderedRows.map(function (row) {
          return row.entity;
        });
      };
      var grid = function () {
        return element.find('.ngViewport');
      };
      var skip = function (idx, direction) {

        // skip highlight if trying to move to a bom child
        return (direction === 'up' && idx > 0 && array()[idx -1 ].bom_parent_id) ||
          (direction === 'down' && idx < array().length - 1 && array()[idx + 1].bom_parent_id)
      };
      var findNext = function (idx, direction) {
        if (direction === 'up') {
          for (var i = idx; i >= 0; i--) {
            if (array()[i].is_bom_parent) {
              return i;
            }
          }

          return idx;
        }
        else {
          for (var i = idx + 1; i < array().length; i++) {
            if (array()[i].is_bom_parent || !array()[i].bom_parent_id) {
              return i;
            }
          };

          return idx;
        }
      };
      var moveUp = function () {
        if (index > 0) {
          if (lastActive) {
            lastActive.active = false;
          }

          if (skip(index, 'up')) {
            index = findNext(index, 'up');
          }
          else {
            index--;
          }

          array()[index].active = true;
          lastActive = array()[index];
        }
      };
      var moveDown = function () {
        if (index < array().length -1) {
          if (lastActive) {
            lastActive.active = false;
          }
          if (skip(index, 'down')) {
            index = findNext(index, 'down');
          }
          else {
            index++;
          }
          array()[index].active = true;
          lastActive = array()[index];
        }
      };

      scope.handleKeydown = function ( evt ) {
        var keycode = evt.keyCode || evt.which;

        switch (keycode) {
          case KEYCODES.down:
            if (array()[index].selected) {
              index = scope.$parent.move('down');
            }
            else {
              moveDown();
            }
            break;
          case KEYCODES.up:
            if (array()[index].selected) {
              index = scope.$parent.move('up');
            }
            else {
              moveUp();
            }
            break;
          case KEYCODES.space:
            scope.toggleSelected();
            break;
          case KEYCODES.enter:
            scope.$parent.toggleEditMode();
            break;
        }

        if (!scope.$$phase) {
          scope.$apply();
        }

        evt.preventDefault();
      };

      scope.toggleSelected = function (row, newIndex) {
        var toggleChildren = function (startingIndex) {
          startingIndex = angular.isUndefined(startingIndex) ? index : startingIndex;
          for (var i = (startingIndex + 1); i < array().length; i++) {
            if (array()[i].bom_parent_id === array()[startingIndex].product_id) {
              array()[i].selected = !array()[i].selected;
            }
            else {
              break;
            }
          }
        };

        if (!scope.editMode) {
          return;
        }
        if (row && row.bom_parent_id) {
          return;
        }

        index = angular.isUndefined(newIndex) ? index : newIndex;
        grid().focus();

        if (lastActive) {
          lastActive.active = false;
        }
        if (lastSelected && lastSelected.ordering !== array()[index].ordering) {
          lastSelected.selected = false;

          if (lastSelected.is_bom_parent) {
            var lastIndex;

            for (var i = 0; i < array().length; i++) {
              if (array()[i].id === lastSelected.id) {
                lastIndex = i;
                break;
              }
            }

            toggleChildren(lastIndex);
          }
        }
        if (row) {
          row.selected = !row.selected;
          lastSelected = row;
          lastActive = undefined;

          if (row.is_bom_parent) {
            toggleChildren();
          }
        }
        else {
          array()[index].selected = !array()[index].selected;
          lastSelected = array()[index];
          lastActive = undefined;

          if (!lastSelected.selected) {
            array()[index].active = true;
            lastActive = array()[index];
          }

          if (array()[index].is_bom_parent) {
            toggleChildren();
          }
        }
      };

      scope.$on('$destroy', () => {
        grid().off('keydown', scope.handleKeydown);
      });

      scope.$on('refocusGrid', function (evt, newIndex) {
        index = newIndex;

        grid().focus();
      });

      scope.$on('endGridReorder', function () {
        array()[index].active = false;
        array()[index].selected = false;

        if (array()[index].is_bom_parent) {
          for (var i = index + 1; i < array().length - 1; i++) {
            array()[i].selected = false;
            array()[i].active = false;
          }
        }
        lastActive = undefined;
        lastSelected = undefined;
        index = -1;
      });

      scope.$watch('editMode', function (editMode) {
        if (editMode) {
          moveDown();
          grid().focus();

          grid()
          .on('keydown', scope.handleKeydown);
        }
        else {
          grid().off('keydown', scope.handleKeydown);
          grid().blur();
        }
      });
    }
  };
}